/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_out': {
    width: 31.999,
    height: 32,
    viewBox: '0 0 31.999 32',
    data: '<path pid="0" data-name="Caminho 17907" d="M3.428 0h14.857a3.429 3.429 0 013.426 3.429v6.857a1.143 1.143 0 11-2.286 0V3.429a1.143 1.143 0 00-1.143-1.143H3.428a1.143 1.143 0 00-1.143 1.143v25.142a1.143 1.143 0 001.143 1.143h14.857a1.143 1.143 0 001.143-1.143v-6.857a1.143 1.143 0 012.286 0v6.857A3.429 3.429 0 0118.286 32H3.429A3.429 3.429 0 010 28.571V3.429A3.428 3.428 0 013.428 0z"/><path pid="1" data-name="Caminho 17908" d="M9.142 14.857h18.956l-3.763-3.763a1.143 1.143 0 011.616-1.616l5.714 5.714a1.13 1.13 0 01.247.371 1.146 1.146 0 01-.248 1.246l-5.715 5.714a1.143 1.143 0 01-1.644-1.588l.028-.028 3.765-3.765H9.142a1.143 1.143 0 110-2.286z"/>'
  }
})
